module.exports = __webpack_public_path__ + "img/user.ddf08723.webp";